<div class="bg_message"></div>
<div class="bottom_message form_cle_chec" id="find_user_send_money">
  <div class="wrap form_add_user">
    <div class="ttl">{{ title }}</div>
    <div class="gs_view search_form" *ngIf="pageMode == 1">
      <div class="message">
        <div class="form_class">
          <div class="ins_space">
            <div class="label">{{ 'Sections.UserSearch.Param1Text' | translate }}</div>
            <input type="text" [(ngModel)]="lastName" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="ins_space">
            <div class="label">{{ 'Sections.UserSearch.Param2Text' | translate }}</div>
            <input type="text" [(ngModel)]="firstName" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="ins_space">
            <div class="label">{{ 'Sections.UserSearch.Param3Text' | translate }}</div>
            <input type="text" [(ngModel)]="middleName" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="ins_space">
            <div class="label">{{ 'Sections.UserSearch.Param4Text' | translate }} </div>
            <select name="" [(ngModel)]="organization" [ngModelOptions]="{standalone: true}">
              <option selected="selected"></option>
              <option value="{{organization.value}}" *ngFor="let organization of organizations">{{organization.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="button_block pos_l_r clrfx">
        <a (click)="search()" class="find_user button small_radius w100 border_blue right">{{ 'Sections.UserSearch.FindText' | translate }}</a>
      </div>
    </div>
    <div class="gs_view user_list" *ngIf="pageMode == 2">
      <div class="message">
        <div class="list_find">
          <div class="ttl">{{ 'Sections.UserSearch.Result1Text' | translate }} {{usersCount}} {{ 'Sections.UserSearch.Result2Text' | translate }}</div>
          <div class="list_user_find scrollarea">

            <label class="checkbox" *ngFor="let user of users">
              <input *ngIf="multiple" type="checkbox" [(ngModel)]="user.checked" name="user{{i}}" [ngModelOptions]="{standalone: true}" />
              <input *ngIf="!multiple" type="radio" name="us_fin" value="{{user.id}}" [(ngModel)]="userId" [ngModelOptions]="{standalone: true}" />
              <div class="checkbox__text">
                <span>{{user.fullName}}</span>
                <div class="tag">{{ 'Sections.UserSearch.OrganizationText' | translate }}: <b>{{user.organization}}</b></div>                
                <div class="tag">{{ 'Sections.UserSearch.DepartmentText' | translate }}: <b>{{user.department}}</b></div>                
                <div class="tag">{{ 'Sections.UserSearch.DivisionText' | translate }}: <b>{{user.division}}</b></div>                
                <div class="tag">{{ 'Sections.UserSearch.UserBlockText' | translate }}: <b>{{user.block}}</b></div>
              </div>
            </label>

          </div>
        </div>
      </div>
      <div class="button_block pos_l_r clrfx">
        <a (click)="back()" class="back_to_filter button small_radius w100 left">{{ 'Sections.UserSearch.BackText' | translate }}</a>
        <a (click)="choose()" class="add_user button small_radius w100 border_blue right">{{ 'Sections.UserSearch.ChooseText' | translate }}</a>
      </div>
    </div>

    <a class="close close_modal_ref" (click)="activeModal.close()"></a>
  </div>
</div>
